const SHARE_CHANNELS = [
	{
		name: 'facebook',
		label: 'Facebook',
		getUrl: ({ url }) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
		icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06C2 17.08 5.66 21.24 10.44 22v-7.03H7.9v-2.91h2.54V9.85c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.88h2.78l-.44 2.91h-2.34V22C18.34 21.24 22 17.08 22 12.06Z"/></svg>',
	},
	{
		name: 'x',
		label: 'X',
		getUrl: ({ url, title }) => `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`,
		icon: '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18.9 2H22l-7.6 8.7L23.3 22H16.6l-5.2-6.8L5.4 22H2.3l8.1-9.3L1.7 2h6.9l4.7 6.2L18.9 2Zm-1.2 18h1.7L7.4 4H5.6l12.1 16Z"/></svg>',
	},
	{
		name: 'linkedin',
		label: 'LinkedIn',
		getUrl: ({ url }) => `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
		icon: '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.03-1.85-3.03-1.86 0-2.14 1.45-2.14 2.94v5.66H9.36V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.38-1.85 3.61 0 4.28 2.38 4.28 5.47v6.27ZM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12ZM7.12 20.45H3.56V9h3.56v11.45Z"/></svg>',
	},
];

export function initShareButtons() {
	const buttons = document.querySelectorAll('.js-share');

	if (!buttons.length) return;

	const isTouch = window.matchMedia('(pointer: coarse)').matches;
	let openPopover = null;
	let openTrigger = null;

	const closePopover = () => {
		if (openPopover) {
			openPopover.remove();
			openPopover = null;
			openTrigger = null;
		}
	};

	document.addEventListener('click', (e) => {
		if (openPopover && !openPopover.contains(e.target) && e.target !== openTrigger && !openTrigger?.contains(e.target)) {
			closePopover();
		}
	});
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape') closePopover();
	});
	window.addEventListener('scroll', closePopover, true);
	window.addEventListener('resize', closePopover);

	const copyToClipboard = async (url) => {
		try {
			if (navigator.clipboard?.writeText) {
				await navigator.clipboard.writeText(url);
				return true;
			}
		} catch (e) {}

		const input = document.createElement('input');
		input.value = url;
		document.body.appendChild(input);
		input.select();
		document.execCommand('copy');
		document.body.removeChild(input);
		return true;
	};

	const buildPopover = (btn, shareData) => {
		const popover = document.createElement('div');
		popover.className = 'share-popover';
		popover.setAttribute('role', 'menu');

		SHARE_CHANNELS.forEach((channel) => {
			const link = document.createElement('a');
			link.className = `share-popover-item share-popover-item--${channel.name}`;
			link.href = channel.getUrl(shareData);
			link.target = '_blank';
			link.rel = 'noopener';
			link.setAttribute('role', 'menuitem');
			link.setAttribute('aria-label', `Share on ${channel.label}`);
			link.innerHTML = channel.icon;
			link.addEventListener('click', (e) => {
				e.preventDefault();
				window.open(link.href, 'share-popup', 'noopener,width=600,height=500');
				closePopover();
			});
			popover.appendChild(link);
		});

		const emailLink = document.createElement('a');
		emailLink.className = 'share-popover-item share-popover-item--email';
		emailLink.href = `mailto:?subject=${encodeURIComponent(shareData.title)}&body=${encodeURIComponent(`${shareData.text ? shareData.text + '\n\n' : ''}${shareData.url}`)}`;
		emailLink.setAttribute('role', 'menuitem');
		emailLink.setAttribute('aria-label', 'Share by email');
		emailLink.innerHTML = '<svg width="16" height="13" viewBox="0 0 16 13" fill="none" aria-hidden="true"><path d="M1 1h14v11H1z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="M1.5 1.5 8 7l6.5-5.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
		emailLink.addEventListener('click', closePopover);
		popover.appendChild(emailLink);

		const copyBtn = document.createElement('button');
		copyBtn.type = 'button';
		copyBtn.className = 'share-popover-item share-popover-item--copy';
		copyBtn.setAttribute('role', 'menuitem');
		copyBtn.setAttribute('aria-label', 'Copy link');
		copyBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><rect x="4.5" y="4.5" width="8" height="8" rx="1.2" stroke="currentColor" stroke-width="1.3"/><path d="M9.5 4V2.7A1.2 1.2 0 0 0 8.3 1.5H2.2A1.2 1.2 0 0 0 1 2.7v6.1a1.2 1.2 0 0 0 1.2 1.2H3.5" stroke="currentColor" stroke-width="1.3"/></svg>';
		copyBtn.addEventListener('click', async () => {
			await copyToClipboard(shareData.url);
			copyBtn.classList.add('is-copied');
			copyBtn.setAttribute('aria-label', 'Copied!');
			window.setTimeout(() => closePopover(), 900);
		});
		popover.appendChild(copyBtn);

		return popover;
	};

	const positionPopover = (btn, popover) => {
		const rect = btn.getBoundingClientRect();
		popover.style.position = 'fixed';
		popover.style.top = `${rect.bottom + 8}px`;
		popover.style.left = `${rect.left}px`;

		document.body.appendChild(popover);

		// Keep the popover on-screen horizontally.
		const popoverRect = popover.getBoundingClientRect();
		const overflowRight = popoverRect.right - window.innerWidth + 8;
		if (overflowRight > 0) {
			popover.style.left = `${rect.left - overflowRight}px`;
		}
	};

	buttons.forEach((btn) => {
		btn.addEventListener('click', async (e) => {
			const url = btn.getAttribute('data-share-url') || window.location.href;
			const title = btn.getAttribute('data-share-title') || document.title;
			const text = btn.getAttribute('data-share-text') || '';

			if (isTouch && navigator.share) {
				try {
					await navigator.share({ title, text, url });
					return;
				} catch (err) {
					return;
				}
			}

			e.stopPropagation();

			if (openTrigger === btn) {
				closePopover();
				return;
			}

			closePopover();

			const popover = buildPopover(btn, { url, title, text });
			positionPopover(btn, popover);
			openPopover = popover;
			openTrigger = btn;
		});
	});
}
